export const selfSelector = (state) => state;